import script from "./FilterSuggestDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSuggestDropdown.vue?vue&type=script&setup=true&lang=js"

import "./FilterSuggestDropdown.vue?vue&type=style&index=0&id=f9b24988&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b24988"]])

export default __exports__